import { createSlice } from "@reduxjs/toolkit";

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  selectedProduct: null,
  lastError: null,
  showUploadFields: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const productsSlice = createSlice({
  name: "products",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setProducts: (state, action) => {
      const { items, totalItems } = action.payload.data;
      state.entities = items || [];
      state.totalCount = totalItems || 0;
      state.listLoading = false;
    },
    resetProducts: (state) => {
      state.entities = null;
      state.totalCount = 0;
      state.listLoading = false;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload?.data;
      state.actionsLoading = false;
    },
    toggleUploadProductFields: (state, action) => {
      state.showUploadFields = action.payload?.status;
    },
  },
});
